import { actionCreator } from '@ardoq/rxbeach';
import {
  APIDashboardColorTheme,
  ArdoqId,
  UnpersistedEntity,
} from '@ardoq/api-types';

const addPrefix = (name: string): `[${string}] ${string}` =>
  `[dashboardColorTheme] ${name}`;

export const createDashboardColorTheme = actionCreator<
  UnpersistedEntity<APIDashboardColorTheme>
>(addPrefix('createDashboardColorTheme'));

// shared, used in dashboard builder and dashboard color theme settings
export const getDashboardColorThemes = actionCreator(
  addPrefix('getDashboardColorThemes')
);

export const setDashboardColorThemes = actionCreator<APIDashboardColorTheme[]>(
  addPrefix('setDashboardColorThemes')
);

export const updateDashboardColorTheme = actionCreator<APIDashboardColorTheme>(
  addPrefix('updateColorTheme')
);

export const setIsDashboardColorThemesLoading = actionCreator<boolean>(
  addPrefix('setIsDashboardColorThemesLoading')
);

export const deleteDashboardColorTheme = actionCreator<APIDashboardColorTheme>(
  addPrefix('deleteColorTheme')
);

export const selectDashboardColorTheme = actionCreator<ArdoqId>(
  addPrefix('selectDashboardColorTheme')
);

export const dashboardColorThemeSelected = actionCreator<{
  id: ArdoqId;
  label: string;
}>(addPrefix('dashboardColorThemeSelected'));

export const allDashboardColorThemesUnselected = actionCreator<{
  label: string;
}>(addPrefix('allDashboardColorThemesUnselected'));

export type RetryableColorThemeRequest =
  | {
      request: 'create';
      retryAction: ReturnType<typeof createDashboardColorTheme>;
    }
  | {
      request: 'save';
      retryAction: ReturnType<
        | typeof updateDashboardColorTheme
        | typeof dashboardColorThemeSelected
        | typeof allDashboardColorThemesUnselected
      >;
    }
  | {
      request: 'delete';
      retryAction: ReturnType<typeof deleteDashboardColorTheme>;
    };

export type FailedColorThemeRequest = RetryableColorThemeRequest & {
  traceId: string | undefined;
};

export const colorThemeRequestFailed = actionCreator<FailedColorThemeRequest>(
  addPrefix('colorThemeRequestFailed')
);
